import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';
import { useStore, useUpdateEffect } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

type GamesFilterProps = {
	enableSelectAll?: boolean;
};

const GamesFilter = React.memo(function GamesFilter({ enableSelectAll = true }: GamesFilterProps): JSX.Element {
	const [{ games, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'game_ids', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();
		onFilter([{ name: 'game_ids', value: '' }]);
	};

	const onSelectAll = () => {
		const availableGames = fiterGamesByProvider(games);
		if (!availableGames || !availableGames.length) return;
		const allValues = availableGames.map((g: PropertyType) => g.value).join(',');
		setFiltersOptions(selectPreselectedOptions(games, allValues));
		onFilter([{ name: 'game_ids', value: allValues }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	const fiterGamesByProvider = (games: PropertyType[]) => {
		let availableGames = [...games];
		const providerIds = filters.find((f: PropertyType) => f.name === 'game_provider_ids')?.value;

		if (games.length && providerIds) {
			availableGames = games?.filter((g) => providerIds.split(',').includes(g.provider_id.toString()));
		}
		return availableGames;
	};

	useEffect(() => {
		setFiltersOptions(games);
	}, [games]);

	useUpdateEffect(() => {
		const filter = find(filters, ['name', 'game_ids'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(games, filter));
	}, [filters]);

	return (
		<Action
			label='Games'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions)?.length ? filtersStyles.Active : ''} `}
			dataId='games-filter'
		>
			<FilterDropdown
				data={fiterGamesByProvider(filterOptions)}
				onChange={onFilterChange}
				isSearchable
				enableSelectAll={enableSelectAll}
				onSelectAll={enableSelectAll ? onSelectAll : undefined}
				selectAllLabel='Select All'
			/>
		</Action>
	);
});

export { GamesFilter };
